"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
/**
 * Function to format a given string to currency

 * @param {string} value - The value to be formatted.
 * @returns {string} - Return formatted string
 */
const formatCurrency = (value) => {
    const val = value
        .replace("$", "")
        .trim()
        .replace(/[^\d.]/g, "");
    const dollar = val !== "" ? "$" : "";
    const amount = val.slice(0, 0) + dollar + val.slice(0, val.length);
    return amount;
};
exports.formatCurrency = formatCurrency;
